module.exports = __webpack_public_path__ + "img/0603-a.f7156600.svg";